// Code generated by tygo. DO NOT EDIT.

//////////
// source: card_dto.go

export interface GetCardsResponse {
  cards: Card[];
}
export interface Card {
  id: number /* int64 */;
  userId: number /* int64 */;
  reviewWord: UserVideoWord;
  contextText: UserVideoWord[];
  dueAt: string;
  youtubeId: string;
  aspectRatio: AspectRatio;
  videoEndMs: number;
}
export interface GetCardCountResponse {
  count: number /* int */;
}
export type CardAction = 'good' | 'again';
export interface PutCardRequest {
  cardId: number /* int64 */;
  action: CardAction;
}
export interface PutCardRequestResponse {
  message: string;
  waterDropletsAwarded: number /* int */;
}
export interface DeleteCardRequest {
  cardId: number /* int64 */;
}

//////////
// source: dictionary_dto.go

/**
 * DTOs
 */
export interface GetDictionaryStatsResponse {
  knownWordCount: number /* int */;
  learningWordCount: number /* int */;
  knownPhraseCount: number /* int */;
  learningPhraseCount: number /* int */;
}
export interface UserWord {
  userWordId: number /* int64 */;
  targetWord: string;
  nativeWord: string;
  status: 'new' | 'learning' | 'known' | 'deleted';
  wordKey: string;
  translationId: number /* int64 */;
}
export interface GetKnownWordsDictionaryResponse {
  knownWords: UserWord[];
  nextPage: number /* int */;
  totalCount: number /* int */;
}
export interface GetSearchWordsResponse {
  words: UserWord[];
  nextPage: number /* int */;
  totalCount: number /* int */;
}
export interface GetLearningWordsDictionaryResponse {
  learningWords: UserWord[];
  nextPage: number /* int */;
  totalCount: number /* int */;
}
export interface PutWordStatusResponse {
  message: string;
  waterDropletsAwarded: number /* int */;
}
export interface GetPhraseRequest {
  startVideoWordId: number /* int64 */;
  endVideoWordId: number /* int64 */;
  /**
   * The name testing string was chosen since we thought we
   * would remove it, but we are keeping it and now it can't
   * change since client versions depend on it. If we change it
   * it must be a backwards compatible change.
   */
  testingString: string;
}
export interface GetPhraseResponse {
  phraseId: number /* int64 */;
  /**
   * this must stay as "phrase". for backwards compatibility.
   */
  phrase: string;
  isPhraseSaved: boolean;
}
export interface PutPhraseSavedRequest {
  phraseId: number /* int64 */;
  lessonId: number /* int64 */;
  isPhraseSaved: boolean;
}
export interface PutUserPhraseStatusRequest {
  phraseId: number /* int64 */;
  phraseStatus: 'known' | 'learning';
}
export interface PutWordStatusRequest {
  wordKey: string;
  newStatus: 'new' | 'learning' | 'known' | 'deleted';
  definitionId: number /* int64 */;
  lessonId: number /* int64 */;
}
export interface GetAllPhrasesResponse {
  phrases: UserPhrase[];
  nextPage: number /* int */;
  totalCount: number /* int */;
}
export type GetSearchPhrasesResponse = GetAllPhrasesResponse;
export interface UserPhrase {
  id: number /* int64 */;
  phraseId: number /* int64 */;
  text: string;
  translation: string;
  lessonId: number /* int64 */;
  chapterId: number /* int64 */;
  phraseStatus: 'known' | 'learning'; // known or learning.
}

//////////
// source: edit_dto.go

/**
 * DTOs
 */
export interface GetCourseInfoWithSizeChaptersRequest {
  courseId: number /* int64 */;
}
export interface GetCourseInfoWithSizeChaptersResponse {
  courseWithSize: CourseWithSize;
  chapters: Chapter[];
}
/**
 * contains size information
 */
export interface CourseWithSize {
  course: Course;
  duration: any /* domain.HHMMSS */;
  totalChapters: number /* int64 */;
}
export interface GetAllCoursesWithSizeResponse {
  courses: CourseWithSize[];
}
export interface PostBroadcastRequest {
  title: string;
  body: string;
}
export interface PostAIQueueChapterRequest {
  chapter: GenChapter;
  forceGenerate: boolean;
}
export interface GenCourse {
  courseName: string;
  description: string;
  chapters: GenChapter[];
}
export interface GenChapter {
  title: string;
  youtubeId: string;
  relativeSequence: number /* int */; // tells us about the order we expect this chapter to be in relative to the other chapters being created
  /**
   * in format HH:MM:SS or MM:SS
   */
  start: string;
  end: string;
  aspectRatio: '16:9' | '9:16';
}
export interface PutChapterRequest {
  chapter: Chapter;
}
export interface PutCourseRequest {
  course: Course;
}
export interface DeleteLessonRequest {
  LessonID: number /* int64 */;
}
export interface DeleteChapterRequest {
  ChapterID: number /* int64 */;
}
export interface PutLessonRequest {
  lesson: Lesson;
}
export interface DeleteVideoWordRequest {
  videoWordId: number /* int64 */;
}
export interface RegenActivityRequest {
  activityType: 'fill' | 'guess' | 'match' | 'write' | 'video' | 'full_video';
  lessonId: number /* int64 */;
  promptFeedback: string;
}
export interface RegenActivityResponse {
  GenericMessageResponse: GenericMessageResponse;
}
export interface RegenTranslationRequest {
  chapterId: number /* int64 */;
  videoWordId: number /* int64 */;
  promptFeedback: string;
}
export interface RegenTranslationResponse {
  GenericMessageResponse: GenericMessageResponse;
}
export interface RegenClickHintRequest {
  chapterId: number /* int64 */;
  videoWordId: number /* int64 */;
  promptFeedback: string;
}
export interface RegenClickHintResponse {
  GenericMessageResponse: GenericMessageResponse;
}
export interface PostVideoWordRequest {
  chapterId: number /* int64 */;
  leftVideoWordId: number /* int64 */;
  displayText: string;
  start: number;
  contextStartMs: number;
  contextEndMs: number;
}
export interface PutLessonDataRequest {
  lesson: Lesson;
  video: VideoActivity;
  fill: FillActivity;
  guess: GuessActivity;
  write: WriteActivity;
  match: MatchActivity;
}
export interface PutVideoWordRequest {
  videoWordId: number /* int64 */;
  clickHint: string;
  displayText: string;
  nativeWord: string;
}
export interface PostCourseRequest {
  course: Course;
}
export interface DeleteCourseRequest {
  CourseID: number /* int64 */;
}
export interface PutTranscriberLoginCookieRequest {
  loginCookie: string;
}
export interface AreCookiesSetResponse {
  areCookiesSet: boolean;
}
export interface AddLessonRequest {
  chapterId: number /* int64 */;
  title: string;
  description: string;
  sequence: number /* int */;
  start: number;
  end: number;
}
export interface AddLessonResponse {
  lessonId: number /* int64 */;
}
export interface SegmentGenerateRequest {
  chapterId: number /* int64 */;
  idealSegmentLength: any /* domain.Seconds */;
}
export interface SegmentGenerateResponse {
  lessonIds: number /* int64 */[];
}
export interface AddSingleSegmentRequest {
  chapterId: number /* int64 */;
  start: number;
  end: number;
}
export interface AddSingleSegmentResponse {
  lessonId: number /* int64 */;
}
export interface GetTranscriptResponse {
  isPerfect: boolean;
  youtubeId: string;
}
export interface GetAllYoutubeVideosResponse {
  youtubeIds: string[];
}
export interface GetAllCourseTopicsResponse {
  topics: CourseTopic[];
}
export interface GetTranslationReportResponse {
  translationReport: TranslationReport;
}
export interface ApplyTranslationReportFixesRequest {
  chapterId: number /* int64 */;
  report: TranslationReport;
}
export interface GetChapterActivitiesResponse {
  lessons: LessonWithActivities[];
}
/**
 * whichover is not empty gets updated
 */
export interface UpdateActivityRequest {
  lessonId: number /* int64 */;
  lessonActivities: LessonActivities;
  fieldToUpdate: 'fill' | 'guess' | 'match' | 'write' | 'video' | 'full_video';
}
export interface LessonWithActivities {
  lesson: Lesson;
  activities: LessonActivities;
}
export interface LessonActivities {
  fill?: FillActivity;
  guess?: GuessActivity;
  match?: MatchActivity;
  write?: WriteActivity;
}
/**
 * TranslationReportItem represents an item in the translation report
 */
export interface TranslationReportItem {
  videoWordId: number /* int */;
  sentence: string;
  nativeWord: string;
  targetWord: string;
  isCorrect: boolean;
  correction: string;
  reasoning: string;
  error?: string;
}
/**
 * TranslationReport represents a collection of translation report items
 */
export interface TranslationReport {
  items: TranslationReportItem[];
}
export interface GetAllCourseLevelsResponse {
  levels: CourseLevel[];
}
export interface AssignTopicToCourseRequest {
  courseId: number /* int64 */;
  topicId: number /* int64 */;
}
export interface AssignLevelToCourseRequest {
  courseId: number /* int64 */;
  levelId: number /* int64 */;
}
export interface CreateCourseTopicRequest {
  courseTopic: CourseTopic;
}
export interface CreateCourseTopicResponse {
  id: number /* int64 */;
  message: string;
}
export interface UpdateCourseTopicRequest {
  courseTopic: CourseTopic;
}
export interface CreateCourseLevelRequest {
  courseLevel: CourseLevel;
}
export interface UpdateCourseLevelRequest {
  courseLevel: CourseLevel;
}
export interface CreateCourseLevelResponse {
  id: number /* int64 */;
  message: string;
}
export interface GetChannelVideoUrlsResponse {
  urls: string[];
}
/**
 * ChapterInfoWithQAInfo DTO for tracking chapter QA metrics
 */
export interface ChapterInfoWithQAInfo {
  chapterId: number /* int64 */;
  title: string;
  description: string;
  youtubeId: string;
  start: number;
  end: number;
  aspectRatio: '16:9' | '9:16';
  sequence: number /* int */;
  published: boolean;
  isFullVidHidden: boolean;
  videoLevel: number /* float64 */;
  cefrLevel: 'No Level' | 'A0' | 'Lower A1' | 'Upper A1' | 'Lower A2' | 'Upper A2' | 'Lower B1' | 'Upper B1' | 'Lower B2' | 'Upper B2' | 'Lower C1' | 'Upper C1' | 'C2';
  qaStatus: QAStatus;
  activitiesPending: number /* int64 */;
  activitiesApproved: number /* int64 */;
  lessonsEdited: number /* int64 */;
  totalLessons: number /* int64 */;
  isManualSetLevel: boolean;
  topics: { id: number /* int64 */; Name: string; Confidence: number /* float64 */; }[];
}
export interface GetChapterWithQAInfoRequest {
  chapterId: number /* int64 */;
}
export interface GetChapterWithQAInfoResponse {
  chapter: ChapterInfoWithQAInfo;
}
export interface PutChapterQAStatusRequest {
  chapterId: number /* int64 */;
  qaStatus: string;
}
export interface ChapterLevel {
  wpmLevel?: number /* float64 */;
  speakingSpeed?: number /* float64 */;
  textLevel?: number /* float64 */;
  finalLevel: number /* float64 */;
  finalCEFR: 'No Level' | 'A0' | 'Lower A1' | 'Upper A1' | 'Lower A2' | 'Upper A2' | 'Lower B1' | 'Upper B1' | 'Lower B2' | 'Upper B2' | 'Lower C1' | 'Upper C1' | 'C2';
}
export type CEFRLevel = 'No Level' | 'A0' | 'Lower A1' | 'Upper A1' | 'Lower A2' | 'Upper A2' | 'Lower B1' | 'Upper B1' | 'Lower B2' | 'Upper B2' | 'Lower C1' | 'Upper C1' | 'C2';
export interface GetChapterLevelResponse {
  chapterLevel: ChapterLevel;
}

//////////
// source: email_dto.go

/**
 * EmailQueueItem DTO
 */
export interface EmailQueueItem {
  id: number /* int64 */;
  userId: number /* int64 */;
  templateType: EmailTemplateType;
  emailSendStatus: EmailSendStatus;
  createdAt: any /* time.Time */;
  sentAt: any /* time.Time */;
  scheduledAt: any /* time.Time */;
  failureReason: string;
  isTestEmail: boolean;
}
export type EmailSendStatus = 'in_queue' | 'sent' | 'failed';
/**
 * EmailTemplate DTO
 */
export interface EmailTemplate {
  templateType: EmailTemplateType;
  body: string;
  subject: string;
  isEnabled: boolean;
}
export type EmailTemplateType = 'welcome' | 'app_use_feedback' | 'churned_user_feedback' | 'custom_email';

//////////
// source: email_requests.go

/**
 * SendEmailRequest represents the request body for sending an email
 */
export interface SendEmailRequest {
  toUserId: number /* int64 */;
  scheduleAt: string; // UTC timestamp in RFC3339 format
  templateType: EmailTemplateType;
}
/**
 * SendTestEmailRequest represents the request body for sending a test email
 */
export interface SendTestEmailRequest {
  toUserId: number /* int64 */;
  templateType: EmailTemplateType;
}
/**
 * SaveTemplateRequest represents the request body for saving an email template
 */
export interface SaveTemplateRequest {
  template: EmailTemplate;
}
/**
 * GetTemplatesResponse represents the response for fetching email templates
 */
export interface GetTemplatesResponse {
  templates: EmailTemplate[];
}
/**
 * GetEmailQueueItemsRequest represents the request for fetching email queue items with filters
 */
export interface GetEmailQueueItemsRequest {
  status?: EmailSendStatus; // Filter by status
  page?: number /* int */;
  limit?: number /* int */;
}
/**
 * GetEmailQueueItemsResponse represents the response for email queue items with pagination
 */
export interface GetEmailQueueItemsResponse {
  items: EmailQueueItem[];
  nextPage: number /* int */;
  totalCount: number /* int */;
}

//////////
// source: json_export.go

/**
 * added in v1.1.0 -> added duration to words. we disallow old imports now to prevent duration overrides.
 */
export const ChapterExportVersion = "1.1.0";
/**
 * Request/Response types
 */
export interface ExportChapterRequest {
  chapterId: number /* int64 */;
}
export interface ExportAllChaptersResponse {
  chapters: ChapterExportFormat[];
}
export interface ExportChapterResponse {
  chapter: ChapterExportFormat;
}
export interface ImportChaptersRequest {
  version: string;
  courseId: number /* int64 */;
  /**
   * optional field that overrides course id to import to a system course
   */
  systemCourseName: string;
  chapters: ChapterExportFormat[];
}
export interface ImportChaptersResponse {
  chapterIds: number /* int64 */[];
}
/**
 * Export Format types - This is the JSON schema for chapter exports
 */
export interface ChapterExportFormat {
  /**
   * We need to be careful about importing/ exporting version compatibility
   */
  exportVersion: string;
  info: ChapterInfoExport;
  fullVideoActivity: VideoActivityExport;
  chapterLevel: ChapterLevelExport;
  lessons: LessonExport[];
}
export interface ChapterInfoExport {
  title: string;
  description: string;
  published: boolean;
  isFullVidHidden: boolean;
  videoLevel: number /* float64 */;
  cefrLevel: string;
  qaStatus: string;
  isManualSetLevel: boolean;
  topics: ChapterTopicExport[];
}
export interface ChapterTopicExport {
  name: string;
  confidence: number /* float64 */;
}
export interface ChapterLevelExport {
  wpmLevel?: number /* float64 */;
  speakingSpeed?: number /* float64 */;
  textLevel?: number /* float64 */;
  finalLevel: number /* float64 */;
  finalCEFR: string;
}
export interface VideoActivityExport {
  videoWords: VideoWordExport[];
  youtubeId: string;
  start: number;
  end: number;
  aspectRatio: '16:9' | '9:16';
}
export interface VideoWordExport {
  start: number;
  /**
   * OPTIONAL VALUE if its not set it will have a value of 0
   */
  duration: number;
  clickHint: string;
  sequence: number /* int */;
  displayText: string;
  targetWord: string;
  nativeWord: string;
}
export interface LessonExport {
  info: LessonInfoExport;
  activities: LessonActivitiesExport;
  videoActivity: VideoActivityInfoExport;
}
export interface LessonInfoExport {
  title: string;
  description: string;
  sequence: number /* int */;
  isEdited: boolean;
}
export interface LessonActivitiesExport {
  fill: FillActivity;
  guess: GuessActivity;
  write: WriteActivity;
  match: MatchActivity;
}
export interface VideoActivityInfoExport {
  youtubeId: string;
  start: number;
  end: number;
  aspectRatio: '16:9' | '9:16';
}

//////////
// source: middlewear.go

export const ClientUpdateRequiredMessage = "CLIENT UPDATE REQUIRED";
/**
 * defined for easy use in the frontend
 */
export const ClientUpdateHeaderKey = "Client-Version";

//////////
// source: nps_dto.go

/**
 * NPSRatingRequest represents the request body for submitting an NPS rating
 */
export interface NPSRatingRequest {
  rating: number /* int */;
  isSkipScore: boolean;
}
/**
 * NPSFeedbackRequest represents the request body for submitting feedback for an NPS rating
 */
export interface NPSFeedbackRequest {
  feedback: string;
}
export interface GetNPSFeedbackRequest {
  startDate: any /* time.Time */;
  endDate: any /* time.Time */;
}
/**
 * NPSResponse represents a Net Promoter Score response in API responses
 */
export interface NPSResponse {
  id: number /* int64 */;
  userId: number /* int64 */;
  score: number /* int */;
  feedback: string;
  createdAt: any /* time.Time */;
  isFollowedUp: boolean;
  email: string;
  displayName: string;
  isSkipScore: boolean;
}
/**
 * NPSCompletedResponse represents the response for the "is NPS completed" check
 */
export interface NPSCompletedResponse {
  shouldSeeNPS: boolean;
}
/**
 * NPSResponseListResponse represents a list of NPS responses
 */
export interface NPSResponseListResponse {
  responses: NPSResponse[];
}
export interface MarkNPSFollowedUpRequest {
  responseId: number /* int64 */;
}

//////////
// source: partner_admin_dto.go

/**
 * DTOs
 */
export interface Partner {
  id: number /* int64 */;
  user_id: number /* int64 */;
  name: string;
  code: string;
}
export interface PartnerWithCounts {
  partner: Partner;
  link_click_count: number /* int */;
  temp_user_signup_count: number /* int */;
  free_user_count: number /* int */;
  trial_user_count: number /* int */;
  premium_user_count: number /* int */;
}
export interface PartnerStats {
  partner_id: number /* int64 */;
  all_refered_user_ids: number /* int64 */[];
  paid_user_ids: number /* int64 */[];
}
/**
 * Request/Response types
 */
export interface RegisterPartnerRequest {
  name: string;
  code: string;
  user_id: number /* int64 */; // it must get linked to an existing user
}
export interface ListPartnersResponse {
  partners: PartnerWithCounts[];
}
export interface PartnerStatsRequest {
  partner_id: number /* int64 */;
}
export interface AdminPartnerStatsResponse {
  partner: PartnerWithCounts;
  users: AdminUserStatResult[];
}
export interface PartnerStatsResponse {
  partner: PartnerWithCounts;
}
export interface UpdatePartnerRequest {
  id: number /* int64 */;
  partner_name: string;
  code: string;
  user_id: number /* int64 */;
}
export interface DeletePartnerRequest {
  id: number /* int64 */;
}

//////////
// source: shared_dto.go

export interface GenericMessageResponse {
  message: string;
}
export interface TransferChapterRequest {
  chapterId: number /* int64 */;
  newCourseId: number /* int64 */;
  oldCourseId: number /* int64 */;
  /**
   * optional value to move the old courseID to the system course name.
   */
  systemName?: SystemCourseName;
}
export type SystemCourseName = string;
export const SystemCourseNameQueue: SystemCourseName = "queue";
export const SystemCourseNameBad: SystemCourseName = "bad";
export const SystemCourseNameEdited: SystemCourseName = "edited";
export const SystemCourseNameExported: SystemCourseName = "exported";
export const SystemCourseNameTriage: SystemCourseName = "triage";
export interface PostForceAlignChapterRequest {
  chapterId: number /* int64 */;
}
export interface UpdateChapterLevelRequest {
  chapterId: number /* int64 */;
}
export interface UpdateChapterTopicsRequest {
  chapterId: number /* int64 */;
}
export interface ErrorResponse {
  error: string;
}
export interface WaterDropletResponse {
  message: string;
  waterDropletsAwarded: number /* int */;
}

//////////
// source: stats_dto.go

/**
 * DTOs
 */
export interface GetPlantStatsResponse {
  chaptersCompleted: number /* int */;
  waterDropletsNeeded: number /* int */;
  waterDropletsCount: number /* int */;
  treesPlanted: number /* int */;
  co2Captured: number /* float64 */;
}
export interface GetUserStatsResponse {
  listeningTime: number /* int */;
  wordsKnown: number /* int */;
  dayStreak: number /* int */;
  waterDropletsCount: number /* int */;
  waterDropletsNeeded: number /* int */;
  treesPlanted: number /* int */;
  chaptersCompleted: number /* int */;
  co2Captured: number /* float64 */;
  level: number /* int */;
  timeToNextLevel: number /* int */;
}
export interface AdminUserStatResult {
  userId: number /* int64 */;
  name: string;
  email: string;
  lastStreakAt: string;
  waterDroplets: number /* int */;
  streak: number /* int */;
  role: 'admin' | 'free' | 'premium' | 'trial' | 'temp' | 'partner' | 'temp_trial' | 'temp_premium';
  isLifeTimePremium: boolean;
  coursesCompleted: number /* int */;
  chaptersCompleted: number /* int */;
  lessonsCompleted: number /* int */;
  activitiesCompleted: number /* int */;
  knownWords: number /* int */;
  learningWords: number /* int */;
  listenTime: number /* int */;
  createdAt: string;
  treesPlanted: number /* int */;
  totalCardRepititions: number /* int */;
  hasPushToken: boolean;
  trialEndsAt: string;
}
export interface GetStatsTableRequest {
  tableType: string;
}
export interface StatsData {
  date: string;
  value: number /* int */;
}
export interface GetStatsTableResponse {
  tableName: string;
  data: StatsData[];
}
export interface PostListenTimeRequest {
  listenTime: number /* int */;
}
export interface GetWaterDropletsResponse {
  waterDropletsCount: number /* int */;
}
export interface GetAdminStatsResponse {
  userStats: AdminUserStatResult[];
  adminStats: AdminStatistics;
}
export interface AdminStatistics {
  freeUserCount: number /* int */;
  premiumUserCount: number /* int */;
  trialUserCount: number /* int */;
  tempUserCount: number /* int */;
  partnerUserCount: number /* int */;
  totalVideoDurationPublished: string;
  totalVideoDurationUnpublished: string;
  videoLevelDurations: VideoLevelDurations;
}
export interface VideoLevelDurations {
  noLevel: string;
  a0: string;
  lowerA1: string;
  upperA1: string;
  lowerA2: string;
  upperA2: string;
  lowerB1: string;
  upperB1: string;
  lowerB2: string;
  upperB2: string;
  lowerC1: string;
  upperC1: string;
  c2: string;
}

//////////
// source: stripe_dto.go

export interface StripeCheckoutResponse {
  clientSecret: string;
  id: string;
}
export interface StripeSessionStatusResponse {
  sessionStatus: string;
  paymentStatus: string;
}

//////////
// source: user_dto.go

/**
 * DTOs
 */
export interface PostTempUserRequest {
  firstName: string;
  email: string;
}
export interface PostTempUserResponse {
  message: string;
  parrotUserId: number /* int64 */;
  token: string;
}
export interface GetUserInfoResponse {
  id: number /* int64 */;
  firstName: string;
  joinDate: string;
  email: string;
  role: UserRole;
  isTemp: boolean;
  isPremium: boolean;
  isTrial: boolean;
  isFree: boolean;
  isTempTrial: boolean;
  isTempPremium: boolean;
  avatarUrl: string;
  hasPushToken: boolean;
  stripeCustomerId: string;
  isFreeTrialUsed: boolean;
  placementResult: CEFRLevel;
}
export interface PutTempToTempTrialRequest {
  parrotUserId: number /* int64 */;
}
export interface PutTempToTempPremiumRequest {
  parrotUserId: number /* int64 */;
}
export interface PutNameRequest {
  name: string;
}
export interface PutTempUserToFullUserRequest {
  parrotUserId: number /* int64 */;
}
export interface PostIOSPushTokenRequest {
  token: string;
}
export type UserRole = 'admin' | 'free' | 'premium' | 'trial' | 'temp' | 'partner' | 'temp_trial' | 'temp_premium';
export interface PutUserRoleRequest {
  userID: number /* int64 */;
  role: UserRole;
}
export interface PostOnboardingRequest {
  onboarding: Onboarding;
}
export interface Onboarding {
  id: number /* int64 */;
  userId: number /* int64 */;
  whyDoYouWantToLearn: 'travel' | 'work' | 'friends_and_family' | 'school' | 'self_improvement' | 'other' | 'no_value' | 'romance';
  whenDoYouWantToBeFluentBy: number;
  howMuchCanYouStudyEachDay: number;
  whatIsYourBiggestChallengeWithLearningLanguage: 'no_time' | 'where_to_start' | 'staying_motivated' | 'grammar_issues' | 'speaking_practice' | 'vocabulary_overload' | 'no_value';
  currentSpanishLevel: 'im_new_to_the_language' | 'i_know_some_common_words' | 'i_can_have_basic_conversations' | 'i_can_talk_about_various_topics' | 'i_can_discuss_most_topics_in_detail' | 'no_value';
  preferredTopic: 'general' | 'travel' | 'food' | 'small_talk' | 'vlogs_grwms' | 'sports' | 'grammar' | 'romance' | 'no_value';
  createdAt: any /* time.Time */;
}
export type LearningReason = 'travel' | 'work' | 'friends_and_family' | 'school' | 'self_improvement' | 'other' | 'no_value' | 'romance';
export type LanguageLearningChallenge = 'no_time' | 'where_to_start' | 'staying_motivated' | 'grammar_issues' | 'speaking_practice' | 'vocabulary_overload' | 'no_value';
export type LanguageLevelOnboarding = 'im_new_to_the_language' | 'i_know_some_common_words' | 'i_can_have_basic_conversations' | 'i_can_talk_about_various_topics' | 'i_can_discuss_most_topics_in_detail' | 'no_value';
export type PreferredTopic = 'general' | 'travel' | 'food' | 'small_talk' | 'vlogs_grwms' | 'sports' | 'grammar' | 'romance' | 'no_value';
export interface UserSettings {
  userId: number /* int64 */;
  isSoundEffectsEnabled: boolean;
}
/**
 * Request and response types
 */
export interface PutUserSettingsRequest {
  settings: UserSettings;
}
export interface GetUserSettingsResponse {
  settings: UserSettings;
}
export interface PostPlacementResultRequest {
  placementResult: CEFRLevel;
}

//////////
// source: user_path_dto.go

/**
 * DTOs
 */
export interface GetAllChaptersRequest {
  courseId: number /* int64 */;
}
export interface GetCourseInfoResponse {
  course: Course;
  chapters: Chapter[];
}
export interface Course {
  courseId: number /* int64 */;
  title: string;
  description: string;
  published: boolean;
  topic: CourseTopic;
  level: CourseLevel;
  isSystemCourse: boolean;
}
export interface CourseWithProgress {
  course: Course;
  totalChapters: number /* int64 */;
  completedChapters: number /* int64 */;
  progress: number /* float64 */;
}
export interface CourseTopic {
  id: number /* int64 */;
  name: string;
  emoji: string;
  displayOrder: number /* int */;
}
export interface CourseLevel {
  id: number /* int64 */;
  name: string;
  difficulty: number /* int */;
}
export interface CourseTree {
  topic: CourseTopic;
  courses: Course[];
}
export interface Chapter {
  chapterId: number /* int64 */;
  youtubeId?: string;
  title: string;
  description: string;
  status: string;
  published: boolean;
  aspectRatio: '16:9' | '9:16';
  isFullVidHidden: boolean;
  videoLevel: number /* float64 */;
  videoLevelText: 'No Level' | 'A0' | 'Lower A1' | 'Upper A1' | 'Lower A2' | 'Upper A2' | 'Lower B1' | 'Upper B1' | 'Lower B2' | 'Upper B2' | 'Lower C1' | 'Upper C1' | 'C2';
  topics: { id: number /* int64 */; Name: string; Confidence: number /* float64 */; }[];
  duration: any /* domain.HHMMSS */;
  qaStatus: QAStatus;
  isManualSetLevel: boolean;
}
export type QAStatus = '' | 'words' | 'activities' | 'done';
export interface GetAllLessonRequest {
  chapterId: number /* int64 */;
}
export interface GetAllLessonsResponse {
  chapter: Chapter;
  lessons: Lesson[];
}
export interface GetCompletedLessonsRequest {
  userId: number /* int64 */;
}
export interface GetCompletedLessonsResponse {
  lessons: UserLessonWithCourse[];
}
export interface PostChapterCompletedRequest {
  chapterId: number /* int64 */;
}
export interface PostChapterCompletedResponse {
  message: string;
  waterDropletsAwarded: number /* int */;
}
export interface PostCourseCompletedRequest {
  courseId: number /* int64 */;
}
export interface PostCourseCompletedResponse {
  message: string;
  waterDropletsAwarded: number /* int */;
}
export interface GetAllCoursesResponse {
  courses: Course[];
}
export interface GetAllCoursesProgressResponse {
  courses: CourseWithProgress[];
}
export interface GetAllCourseTreesResponse {
  courseTrees: CourseTree[];
}
export interface GetLessonDataRequest {
  lessonId: number /* int64 */;
}
export type ProgressStatus = 'completed' | 'current' | 'locked';
/**
 * DTOs
 */
export interface Lesson {
  lessonId: number /* int64 */;
  title: string;
  description: string;
  status: ProgressStatus;
  sequence: number /* int */;
  start: number;
  end: number;
  isEdited: boolean;
}
export interface UserLesson {
  userId: number /* int64 */;
  lessonId: number /* int64 */;
  completedAt: any /* time.Time */;
}
export interface UserLessonWithCourse {
  userLesson: UserLesson;
  courseId: number /* int64 */;
}
export type AspectRatio = '16:9' | '9:16';
export interface VideoActivity {
  youtubeId: string;
  start: number /* int */;
  end: number /* int */;
  aspectRatio: AspectRatio;
  userVideoWords: UserVideoWord[];
}
export type UserWordStatus = 'new' | 'learning' | 'known' | 'deleted';
export interface UserVideoWord {
  videoWordId: number /* int64 */;
  start: number /* int */;
  /**
   * OPTIONAL VALUE if its not set it will have a value of 0
   */
  duration: number /* int */;
  status: UserWordStatus;
  wordKey: string;
  displayText: string;
  clickHint: string;
  definition: Definition;
}
export interface Definition {
  definitionId: number /* int64 */;
  targetWord: string;
  nativeWord: string;
  wordKey: string;
}
/**
 * These types are EXPORT VERSION sensitive, careful changeing
 */
export interface FillActivity {
  start: number /* int */;
  end: number /* int */;
  youtubeId: string;
  aspectRatio: AspectRatio;
  fillInTheBlank: FillInTheBlank;
  approved: boolean;
}
export interface FillInTheBlank {
  question: string;
  options: Option[];
}
export interface Option {
  choice: string;
  correct: boolean;
}
export interface GuessActivity {
  question: string;
  options: Option[];
  approved: boolean;
}
/**
 * These types are EXPORT VERSION sensitive, careful changeing
 */
export interface MatchActivity {
  matchData: MatchData[];
  approved: boolean;
}
export interface MatchData {
  spanish: string;
  english: string;
}
/**
 * These types are EXPORT VERSION sensitive, careful changeing
 */
export interface WriteActivity {
  question: string;
  answer: string;
  approved: boolean;
}
export interface SpeakActivity {
  youtubeId: string;
  start: number;
  end: number;
  aspectRatio: AspectRatio;
  userVideoWords: UserVideoWord[];
  approved: boolean;
}
export type SentenceActivity = SpeakActivity;
export interface PostLessonCompletedRequest {
  lessonId: number /* int64 */;
}
export interface PostLessonCompletedResponse {
  message: string;
  waterDropletsAwarded: number /* int */;
}
export interface PostActivityCompleteRequest {
  lessonId: number /* int64 */;
  activityType: string;
}
export interface PostActivityCompleteResponse {
  message: string;
  waterDropletsAwarded: number /* int */;
}
export interface PutLessonCompletedRequest {
  lessonId: number /* int64 */;
}
export interface PostActivityCompletedRequest {
  lessonId: number /* int64 */;
  activityType: 'fill' | 'guess' | 'match' | 'write' | 'video' | 'full_video';
}
export interface GetLessonDataResponse {
  lesson: Lesson;
  video: VideoActivity;
  fill: FillActivity;
  guess: GuessActivity;
  match: MatchActivity;
  write: WriteActivity;
  speak: SpeakActivity;
  sentence: SentenceActivity;
  isLastChapter: boolean;
  isLastLesson: boolean;
  nextLessonId: number /* int64 */;
  /**
   * course id the lesson belongs to
   */
  courseId: number /* int64 */;
}

//////////
// source: word_err_dto.go

export interface PostWordErrorRequest {
  videoWordId: number /* int64 */;
  feedback: string;
  lessonId: number /* int64 */;
}
export interface PutResolveWordErrorRequest {
  wordErrorId: number /* int64 */;
  isResolved: boolean;
}
export interface GetWordErrorsResponse {
  wordErrors: WordError[];
}
export interface WordError {
  id: number /* int64 */;
  userId: number /* int64 */;
  email: string;
  displayName: string;
  videoWordId: number /* int64 */;
  lessonId: number /* int64 */;
  chapterId: number /* int64 */;
  displayWord: string;
  targetWord: string;
  nativeWord: string;
  clickHint: string;
  /**
   * one word is wrapped in <word>...</word> tag
   */
  context: string;
  timestamp: string;
  isResolved: boolean;
  feedback: string;
}
